import React from "react";
import Loader from "react-loader-spinner";

export default function Spinner() {
    return (
        <>
            <div style={{display: 'flex', justifyContent: 'center'}}>
                <Loader
                    type="ThreeDots"
                    color="#0066a1"
                    secondaryColor="Blue"
                    height={100}
                    width={100}
                    timeout={60000}
                />
            </div>
        </>
    );
}
